export var DocumentTypesEnum;
(function (DocumentTypesEnum) {
    DocumentTypesEnum["DNI"] = "DNI";
    DocumentTypesEnum["CC"] = "CC";
    DocumentTypesEnum["NIT"] = "NIT";
    DocumentTypesEnum["CE"] = "CE";
    DocumentTypesEnum["TI"] = "TI";
    DocumentTypesEnum["PP"] = "PP";
    DocumentTypesEnum["PAS"] = "PAS";
    DocumentTypesEnum["RUC"] = "RUC";
    DocumentTypesEnum["CI"] = "CI";
    DocumentTypesEnum["RUT"] = "RUT";
    DocumentTypesEnum["CURP"] = "CURP";
    DocumentTypesEnum["RFC"] = "RFC";
})(DocumentTypesEnum || (DocumentTypesEnum = {}));
